import { createFileRoute } from '@tanstack/react-router';

import { MapPage } from '~/features/map/map-page';

/**
 * The Business map (docs/plans/business-map.md Decided 5): the setup sketch,
 * kept as the workspace's map. First in the sidebar's Workspace group, on
 * Workspace details beside Setup, and in ⌘K.
 */
export const Route = createFileRoute('/_app/business/map')({
  component: MapPage,
});
